import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Link, Redirect, Route, Switch, useHistory } from 'react-router-dom';
import CommonPages from './Components/CommonScreens/CommonPages/CommmonPages';
import Episode1_MainPage from './Components/Episode1/Episode1_MainPage/Episode1_MainPage';
import Episode2_MainPage from './Components/Episode2/Episode2_MainPage/Episode2_MainPage';
import AdminPortal from './AdminPortal/AdminPortal';
import { useEffect } from 'react';

// window.location.assign('/cp');

function App() {
  var history = useHistory();

  // window.onload=()=>{
  // }


  return (
    <div className="App">

      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={CommonPages} ></Route>
          <Route exact path='/admindashboard' component={AdminPortal} />
          <Redirect to='/' />
          {/* <Route  exact path='/episode2' component={Episode2_MainPage} /> */}
          {/* <Route path='*'><Redirect to='/cp'></Redirect></Route> */}

        </Switch>
      </BrowserRouter>


    </div>
  );
}

export default App;
